import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, useColorModeValue } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { servicesData } from "../assets/services";
import { Service } from "../global/types";
import ServicesCard from "../components/ServicesCard";

export default function EnvironmentPage() {
    const [envGovernmentArray, setEnvGovernmentArray] = useState<Service[]>([]);
    const [envEuropeanArray, setEnvEuropeanArray] = useState<Service[]>([]);
    const [envNgoArray, setEnvNgoArray] = useState<Service[]>([]);

    const getEnvGovernment = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΠεριβαλλοΚυβερνητικοί Οργανισμοί");

    const getEnvEuropean = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΠεριβαλλοΕυρωπαϊκοί Οργανισμοί");

    const getEnvNgos = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΠεριβαλλοΜη Κυβερνητικοί Οργανισμοί");

    useEffect(() => {
        setEnvGovernmentArray(getEnvGovernment());
    }, []);

    useEffect(() => {
        setEnvEuropeanArray(getEnvEuropean());
    }, []);

    useEffect(() => {
        setEnvNgoArray(getEnvNgos());
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const tabColor = useColorModeValue("primary", "light");

    return (
        <Box>
            <Tabs variant="enclosed" colorScheme={tabColor}>
                <TabList flex="1">
                    <Tab fontWeight="bold">Κυβερνητικοί Οργανισμοί</Tab>
                    <Tab fontWeight="bold">Ευρωπαϊκοί Οργανισμοί</Tab>
                    <Tab fontWeight="bold">Μη Κυβερνητικοί Οργανισμοί</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel>
                        {envGovernmentArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                    <TabPanel>
                        {envEuropeanArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                    <TabPanel>
                        {envNgoArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
}